export const raffleTicketItem = {
	wrapper: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'center',
	},

	counterWrap: {
		display: 'flex',
		borderRadius: '8px',
		border: '1px solid var(--neutral-100)',
		padding: '8px 15px',
		alignItems: 'center',
	},

	counter: {
		color: 'var(--neutral-900)',
	},

	counterDisabled: {
		color: 'var(--neutral-300)',
	},

	btn: {
		'& svg path': {fill: 'var(--neutral-900)'},
		minWidth: '44px',
	},
	btnDisabled: {
		cursor: 'none',
		'& svg path': {fill: 'var(--neutral-300)'},
		minWidth: '44px',
	},

	subtotal: {
		color: 'var(--primary-700)',
	},

	column: {
		width: '80px',
	},

	lastColumn: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
};
